import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

class IconText extends React.PureComponent {
    constructor(props) {
        super(props);

        this.getAnchor = this.getAnchor.bind(this);
        this.getButton = this.getButton.bind(this);
    }

    getAnchor(content) {
        const {
            iconTextStyle, href, clickHandler, testid,
        } = this.props;

        return (
            <a
                data-testid={testid}
                onClick={clickHandler}
                href={href}
                target="_blank"
                className={`${styles['icon-text']} ${iconTextStyle}`}
                rel="noreferrer"
            >
                {content}
            </a>
        );
    }

    getButton(content) {
        const {
            iconTextStyle, clickHandler, testid,
        } = this.props;

        return (
            <button
                data-testid={testid}
                type="button"
                onClick={clickHandler}
                className={`${styles['icon-text']} ${styles.button} ${iconTextStyle}`}
            >
                {content}
            </button>
        );
    }

    render() {
        const {
            text, iconPath, svgWidth, svgHeight, svgViewBox, type,
        } = this.props;

        const content = (
            <>
                <svg width={svgWidth} height={svgHeight} viewBox={svgViewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d={iconPath} fill="#323232" />
                </svg>
                <p>{text}</p>
            </>
        );

        if (type === 'button') {
            return this.getButton(content);
        }

        return this.getAnchor(content);
    }
}

IconText.propTypes = {
    text: PropTypes.string.isRequired,
    iconPath: PropTypes.string.isRequired,
    svgWidth: PropTypes.string.isRequired,
    svgHeight: PropTypes.string.isRequired,
    svgViewBox: PropTypes.string.isRequired,
    iconTextStyle: PropTypes.string,
    clickHandler: PropTypes.func,
    href: PropTypes.string,
    type: PropTypes.string.isRequired,
    testid: PropTypes.string,
};

IconText.defaultProps = {
    href: null,
    clickHandler: () => { },
    iconTextStyle: '',
    testid: '',
};

export default IconText;
